import React from 'react';
import Filters from '../../components/Filters';
import { Form } from 'react-bootstrap';
import MultiSelectField from '../../components/form/MultiSelectField';

const FiltersPartial = (props) => {
    const { filtersModel, setFiltersModel } = props;

    const onBranchSelect = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_ids: [...(prevState.branch_ids || []), selectedOption.id] }
        })
    }

    const onBranchRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, branch_ids: prevState.branch_ids.filter((id) => id !== removedOption.id) }
        })
    }

    const onStatusAdded = (selectedItems, selectedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, status: [...(prevState.status || []), selectedOption.id] }
        })
    }

    const onStatusRemove = (selectedItems, removedOption) => {
        setFiltersModel((prevState) => {
            return { ...prevState, status: prevState.status.filter((id) => id !== removedOption.id) }
        })
    }

    return <Filters filtersModel={filtersModel} setFiltersModel={setFiltersModel}>
        <div>
            <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <MultiSelectField
                    options={[
                        {
                            id: 'draft',
                            name: 'Draft'
                        },
                        {
                            id: 'submitted',
                            name: 'Submitted'
                        },
                        {
                            id: 'pending',
                            name: 'Pending'
                        },
                        {
                            id: 'accepted',
                            name: 'Accepted'
                        },
                        {
                            id: 'rejected',
                            name: 'Rejected'
                        },
                        {
                            id: 'partially_accepted',
                            name: 'Partially Approved'
                        },
                        {
                            id: 'cancelled_registration',
                            name: 'Cancelled Registration'
                        }
                    ]}
                    fieldName="status"
                    stateModel={filtersModel}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onStatusAdded}
                    onRemove={onStatusRemove}
                />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Label>Circle</Form.Label>
                <MultiSelectField
                    options={[]}
                    fieldName="branch_ids"
                    stateModel={filtersModel}
                    dynamicOptions={{
                        dependsOnFields: [],
                        apiName: "branches",
                        dataAttr: "branches",
                    }}
                    labelAttr="name"
                    valueAttr="id"
                    displayValue="name"
                    onSelect={onBranchSelect}
                    onRemove={onBranchRemove}
                />
            </Form.Group>
        </div>
    </Filters>
};

export default FiltersPartial;
